/* Yorkies Gram custom scripts (built on Dawn) */
(function () {
  'use strict';

  /* ---------- Cart reservation timer ----------
     One global interval updates every [data-yg-timer] element, so the timer
     keeps running when Dawn re-renders the cart drawer HTML. */
  var TIMER_KEY = 'yg-cart-timer-end';

  function readEnd() {
    try {
      return parseInt(window.sessionStorage.getItem(TIMER_KEY), 10) || 0;
    } catch (e) {
      return 0;
    }
  }

  function writeEnd(value) {
    try {
      window.sessionStorage.setItem(TIMER_KEY, String(value));
    } catch (e) {
      /* storage unavailable: timer still runs in memory */
    }
  }

  var memoryEnd = 0;

  function getEnd(minutes) {
    var end = readEnd() || memoryEnd;
    if (!end || end <= Date.now()) {
      end = Date.now() + minutes * 60 * 1000;
      memoryEnd = end;
      writeEnd(end);
    }
    return end;
  }

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function tickTimers() {
    var timers = document.querySelectorAll('[data-yg-timer]');
    if (!timers.length) return;
    var minutes = parseInt(timers[0].getAttribute('data-minutes'), 10) || 10;
    var remaining = Math.max(0, getEnd(minutes) - Date.now());
    var text = pad(Math.floor(remaining / 60000)) + ':' + pad(Math.floor((remaining % 60000) / 1000));
    timers.forEach(function (el) {
      el.textContent = text;
    });
  }

  setInterval(tickTimers, 1000);
  document.addEventListener('DOMContentLoaded', tickTimers);

  /* ---------- Upsell add to cart ---------- */
  function sectionIdsForCart() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      return drawer.getSectionsToRender().map(function (s) {
        return s.id;
      });
    }
    return [];
  }

  document.addEventListener('change', function (event) {
    var select = event.target.closest('[data-yg-upsell-select]');
    if (!select) return;
    var card = select.closest('.yg-upsell__card');
    var option = select.options[select.selectedIndex];
    var button = card.querySelector('[data-yg-upsell-add]');
    var price = card.querySelector('[data-yg-upsell-price]');
    var compare = card.querySelector('[data-yg-upsell-compare]');
    if (button) button.setAttribute('data-variant-id', select.value);
    if (price) price.textContent = option.getAttribute('data-price');
    if (compare) {
      var compareText = option.getAttribute('data-compare');
      compare.textContent = compareText || '';
      compare.hidden = !compareText;
    }
  });

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-yg-upsell-add]');
    if (!button) return;
    event.preventDefault();

    var variantId = button.getAttribute('data-variant-id');
    if (!variantId) return;
    button.setAttribute('aria-busy', 'true');

    var drawer = document.querySelector('cart-drawer');
    var sections = sectionIdsForCart();
    var body = { items: [{ id: Number(variantId), quantity: 1 }] };
    if (drawer && sections.length) {
      body.sections = sections;
      body.sections_url = window.location.pathname;
    }

    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (state) {
        if (state.status) {
          alert(state.description || state.message);
          return;
        }
        if (drawer && state.sections && typeof drawer.renderContents === 'function') {
          var item = state.items && state.items[0] ? state.items[0] : {};
          drawer.renderContents({ id: item.key || item.id, sections: state.sections });
          if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'yg-upsell', cartData: state });
          }
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
      })
      .catch(function () {
        window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      })
      .finally(function () {
        button.removeAttribute('aria-busy');
      });
  });

  /* ---------- Simple carousel (testimonials) ---------- */
  if (!customElements.get('yg-carousel')) {
    customElements.define(
      'yg-carousel',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-yg-carousel-track]');
          var prev = this.querySelector('[data-yg-carousel-prev]');
          var next = this.querySelector('[data-yg-carousel-next]');
          if (!this.track) return;
          if (prev) prev.addEventListener('click', this.move.bind(this, -1));
          if (next) next.addEventListener('click', this.move.bind(this, 1));
        }

        move(direction) {
          var card = this.track.firstElementChild;
          if (!card) return;
          var gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          this.track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
        }
      }
    );
  }
})();
